import React, { useState, useEffect } from "react";
import { capitalizeWords } from "../ConfiguracionListado/helper/CapitalizeWords";
import { FormatMoney } from '../../../Helpers/FormatNumber'
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../components/LoaderScreen";
import SaveIcon from '@mui/icons-material/Save';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import { ModalCarruselImagenes } from "./ModalCarruselImagenes";
import CollectionsIcon from '@mui/icons-material/Collections';
import { useRef } from "react";
import AspersoraIcon from "../../../Styles/ProductoAliado/aspersor.png"
import RemolqueIcon from "../../../Styles/ProductoAliado/Remolque.png"
import MolinoIcon from "../../../Styles/ProductoAliado/molino.png"
import FertilizacionIcon from "../../../Styles/ProductoAliado/arado.png"

export const TablaListadoPreciosContainer = ({ datos, ObtenerListado, filtrar, setFiltrar, setKeyFiltrado }) => {
    const [openModal, setOpenModal] = useState(false);
    const [imagenes, setImagenes] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const containerRef = useRef(null);

    // console.log(guardar)

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });




    const handleOpen = async (rowData, imagen) => {
        // console.log(imagen)
        if (imagen === "N") {
            return
        }
        else {
            setSelectedRow(rowData);
            setLoader({ ...loader, mostrar: true });

            try {
                const result = await request.get(`ImagenesProductoAliado/BuscarImagenes?idinventario=${rowData.idinventario}`);

                if (result && result.length > 0) {
                    setImagenes(result);
                    setOpenModal(true);
                    setLoader({ ...loader, mostrar: false });
                } else {
                    Swal.fire("Imagenes", "Este tractor no cuenta con imagenes", "warning");
                    setLoader({ ...loader, mostrar: false });
                }
            } catch (error) {
                console.error(error);
            }
        }

    };

    const handleClose = () => setOpenModal(false);

    // console.log(imagenes)

    const onEstatus = (estatus) => {
        if (estatus === "L") {
            return "info-estatus-circulo circulo-verde"
        }
        else if (estatus === "A") {
            return "info-estatus-circulo circulo-amarillo"
        }
        else if (estatus === "V") {
            return "info-estatus-circulo circulo-rojo"
        }
    }


    const onFiltrar = (filtro) => {
        setFiltrar(!filtrar)
        setKeyFiltrado(filtro)
    }

    const getMonthName = (dateString) => {
        const currentDate = new Date();  // Obtiene la fecha actual
        const currentMonth = currentDate.getMonth();  // Obtiene el número de mes (0 - 11)

        if (!dateString) return '';

        const [day, month, year] = dateString.split('/');
        const monthNames = [
            'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ];

        // Concatenamos el nombre del mes actual y el mes del dateString
        return monthNames[currentMonth] + ' - ' + monthNames[parseInt(month) - 1];
    };

    const familiasOrdenadas = ["Aspersoras", "Remolques", "Molinos", "Equipos de Fertilización"];

    const clasificarFamilia = (modelo) => {
        if (modelo.toLowerCase().includes("aspersora")) return "Aspersoras";
        if (modelo.toLowerCase().includes("remolque")) return "Remolques";
        if (modelo.toLowerCase().includes("molino")) return "Molinos";
        return "Equipos de Fertilización";
    };

    const datosAgrupados = datos.filter(dato => dato.estatus === "L").reduce((acc, dato) => {
        const familia = clasificarFamilia(dato.modelo_descripcion);
        if (!acc[familia]) acc[familia] = [];
        acc[familia].push(dato);
        return acc;
    }, {});

    const [stickyHeaders, setStickyHeaders] = useState({});

    useEffect(() => {
        const handleScroll = () => {
            if (!containerRef.current) return;

            const rows = containerRef.current.querySelectorAll(".familia-header");
            let currentHeader = null;

            rows.forEach(row => {
                const rect = row.getBoundingClientRect();
                if (rect.top <= 60) { // Ajusta la altura según sea necesario
                    currentHeader = row.innerText;
                }
            });

            setStickyHeaders(prevState => ({
                ...prevState,
                current: currentHeader,
            }));
        };

        if (containerRef.current) {
            containerRef.current.addEventListener("scroll", handleScroll);
        }

        return () => {
            if (containerRef.current) {
                containerRef.current.removeEventListener("scroll", handleScroll);
            }
        };
    }, [containerRef.current]);

    const obtenerIconoFamilia = (familia) => {
        switch (familia) {
            case 'Aspersoras':
                // return <AgricultureOutlinedIcon />;
                return <img src={AspersoraIcon} alt="Aspersora" className="img-trilladora" />;
            case 'Remolques':
                return <img src={RemolqueIcon} alt="Remolque" className="img-trilladora" />;
            case 'Molinos':
                return <img src={MolinoIcon} alt="Molino" className="img-trilladora" />;
            default:
                return <img src={FertilizacionIcon} alt="Cabezal" className="img-trilladora" />;
        }
    };


    return (
        <div className="listado-precios-container">
            <LoaderScreen loader={loader} />
            <div className="paliado-listado-precios-visualizacion-container-table scroll-4">
                <table cellSpacing={0} cellPadding={0}>
                    <thead>
                        <tr>
                            <th className="celda-vacia-1"></th>
                            <th className='celda-circulo celda-fija'>

                            </th>
                            <th className="celda-vacia-2"></th>
                            <th className="celda-fija-2">
                                MODELO
                            </th>
                            <th className="celda-fija-3">
                                <div>N.E</div>
                            </th>
                            <th>
                                <div>MARCA</div>
                            </th>
                            <th>
                                <div>SUCURSAL</div>
                            </th>
                            <th>
                                <div>PRECIO</div>
                            </th>
                            <th>
                                <div>ESTATUS</div>
                            </th>
                            <th>
                                <div>PROMOCION</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {familiasOrdenadas.map(familia => (
                            datosAgrupados[familia] ? (
                                <React.Fragment key={familia}>
                                    <tr className="familia-header sticky-familia">
                                        <td colSpan={5} className="celda-fija-familia">
                                            <div className="celda-titulo-familia">
                                                {obtenerIconoFamilia(familia)}
                                                {familia.toUpperCase()}
                                            </div>
                                        </td>
                                        {/* <td></td> */}
                                        <td className="celda-familia"></td>
                                        <td className="celda-familia"></td>
                                        <td className="celda-familia"></td>
                                        <td className="celda-familia"></td>
                                        <td className="celda-familia"></td>
                                    </tr>
                                    {datosAgrupados[familia].map((datos, index) => (
                                        <tr key={datos.id || index}>
                                            <td className="celda-circulo celda-fija-numero">{index + 1}</td>
                                            <td className="celda-circulo celda-fija">
                                                <div className={onEstatus(datos.estatus)}></div>
                                            </td>
                                            <td className="celda-img celda-fija-img">
                                                <div className={datos.tiene_imagen === "S" ? "img" : "img-sin-color"} onClick={() => handleOpen(datos, datos.tiene_imagen)}>
                                                    <CollectionsIcon />
                                                </div>
                                            </td>
                                            <td className="celda-modelo celda-fija-3">{datos.modelo_descripcion}</td>
                                            <td className="celda-numecon celda-fija-4">{datos.ne}</td>
                                            <td className="celda-marca ta-center">{datos.marca}</td>
                                            <td className="celda-sucursal">{datos.nombre_sucursal}</td>

                                            <td className='celda-importe ta-center'>{FormatMoney(datos.precio_lista)}</td>
                                            <td className='celda-estado'>{datos.estatus === "L" ? "LISTO PARA LA VENTA" : datos.estatus === "A" ? "ACONDICIONANDO" : "NO IDENTIFICADO"}</td>
                                            <td className="celda-promocion">{datos.promocion ? datos.promocion.toUpperCase() : ''}{datos.promocion ? " VIGENCIA AL " + capitalizeWords(datos.vigencia) : ''}</td>
                                        </tr>
                                    ))}
                                </React.Fragment>
                            ) : null
                        ))}
                    </tbody>
                </table>
                {/* )  */}
            </div>

            {/* <div className="listado-precios-footer-container">
                <div className="listado-precios-info-container">
                    <div className="info-estatus">

                        <div className="info-estatus-container-complete green" onClick={() => onFiltrar("L")}>
                            <div className="info-estatus-circulo circulo-verde"></div>
                            Listo para la venta
                        </div>

                        <div className="info-estatus-container-complete green" onClick={() => onFiltrar("A")}>
                            <div className="info-estatus-circulo circulo-amarillo"></div>
                            Acondicionando
                        </div>

                        <div className="info-estatus-container-complete green" onClick={() => onFiltrar("T")}>
                            <div className="info-estatus-circulo circulo-dividido"></div>
                            Todos
                        </div>

                    </div>
                    <div></div>
                </div>
            </div> */}
            <ModalCarruselImagenes open={openModal} handleClose={handleClose} datos={selectedRow} imagenesBD={imagenes} />
        </div>
    )
}